module.exports = __webpack_public_path__ + "img/calendar_black.8d29fa37.png";